import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Container } from "../../../Components/StyledComponents/NftMarketStyledComponents";
import NftMarketHomepage from "../NftMarketPage/NftMarketHomepage";
import BackgroundBanner from "../NftSpecificPage.js/BackgroundBanner";
import { useLocation, useNavigate } from "react-router-dom";
import environmentVariables from "../../../config/environmentVariables"
const HashImg          = `${environmentVariables?.cdnUrl}HashImg.png`
const CollectionBoxImg = `${environmentVariables?.cdnUrl}girl.gif`

const Root = styled.div``;

const NftMarketContainerTopSection = styled.div`
  display: block;
  justify-content: space-between;
  padding-bottom: 5rem;
  width: 91%;
  z-index: 999999;
  padding: 0 5rem;
  @media (max-width: 1260px) {
    padding: 0 5.5rem;
    width: 89%;
  }
  @media (max-width: 1100px) {
    z-index: 1;
  }
  @media (max-width: 1024px) {
    padding: 0 2.5rem;
    width: 88%;
  }
  @media (max-width: 430px) {
    padding: 0rem;
    width: 88%;
  }
`;
const BottomContainer = styled.div`
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-align-items: flex-start;
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  width: 100%;
  padding: 0 2rem;
  margin-top: 80px;
`;
const LeftContainer = styled.div`
  width: 50%;
  margin: 0 20px;
`;
const ImageContainer = styled.div``;
const RightContainerWrapper = styled.div`
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-items: flex-start;
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  text-align: right;
  width: 50%;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  background-color: #151a1c;
  border-radius: 10px;
  padding: 30px;
`;
const NftCategoryHash = styled.div`
  display: flex;
`;
const NftCategory = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: #490d81;
  text-transform: uppercase;
  background-color: #d3b1f3;
  padding: 10px 30px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  ${(p) =>
    p.rare &&
    `
    background-color: #a5e3b8;
    color: #2b713e;
  `};
  ${(p) =>
    p.common &&
    `
    background-color: #dddddd;
    color: #535353;
  `};
`;
const NftHash = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
`;
const LordImage = styled.img`
  width: 25px;
  margin-right: 10px;
`;
const NameText = styled.text`
  font-size: 46px;
  font-weight: 600;
  text-transform: capitalize;
`;
const CollectionText = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
`;

const CollectionTextHead = styled.div`
  font-size: 16px;
  color: #6a6a6a;
  font-weight: 600;
`;

const CollectionTextName = styled.div`
  font-size: 22px;
  color: #dfdfdf;
`;

const CollectionTextFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
`;

const CollectionImg = styled.img`
  width: 60px;
  height: 60px;
  background-color: #000;
  border-radius: 10px;
`;
const Text = styled.text`
  font-family: sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  margin: 10px 0;
  color: #6a6a6a;
  ${(p) =>
    p.CommonPistol &&
    `
line-height: 10px;
color: #6a6a6a;
margin-bottom:15px;
font-size: 16px;
font-weight:600;
display:flex;
align-items: flex-start;
flex-direction: column;
`}
`;
const TextValue = styled.div`
  font-weight: 700;
  font-size: 40px;
  line-height: 38px;
  color: #f3f3f3;
  padding-top: 10px;
`;
const Span = styled.span`
  color: #9b9b9b;
  font-size: 16px;
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 30px;
`;
const PopUpContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #181718;
  border-radius: 15px;
`;
const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 80px;

  @media (max-width: 1024px) {
    padding: 20px 30px;
  }

  @media (max-width: 930px) {
    padding: 20px 15px;
  }
  @media (max-width: 550px) {
    padding: 20px 55px;
  }
  @media (max-width: 425px) {
    padding: 20px 75px;
  }
`;
const TotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;
const FloorDiscountContainer = styled.div``;
const Dropdown = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  font-family: sans-serif;
  color: #ffffff;
`;
const DropdownContainer = styled.div``;
const DropDownTextWrapper = styled.div`
  display: flex;
`;
const ButtonWrapper2 = styled.div`
  margin: 30px 0;
  width: 100%;
`;
const Button2 = styled.button`
  color: #88fefe;
  background: #203736;
  width: 100%;
  padding: 18px;
  border-radius: 30px;
  font-size: 18px;
  outline: none;
  border: none;
  cursor: pointer;
`;
const Button = styled.button`
  background: linear-gradient(45deg, #1a6d7e, #04a1c1);
  border-radius: 30px;
  outline: none;
  border: none;
  font-size: 18px;
  padding: 20px 80px;
  margin: 25px 0;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  }
`;
const ButtonWrapper = styled.div`
  width: 100%;
`;
const NameWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  text-align: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 0 0 30px 0px;
  border-bottom: 1px solid #2a2a2a;
  padding-bottom: 30px;
  width: 100%;
`;

const NameTextMain = styled.text`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

const ViewNftComponent = ({ allContractDetails }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const location = useLocation();
  const { address, tokenId, listedData, price } = location.state;
  const navigate = useNavigate(null);
  useEffect(() => {
    console.log(allContractDetails,'marketplacelistingpage')
    if (!allContractDetails) {
      navigate("/nftMarket");
    }
  }, [allContractDetails]);
  // console.log("taygytayyt", listedData , price, address, tokenId , price !== undefined && price)

  return (
    <Root>
      <Container>
        <NftMarketContainerTopSection>
          <NftMarketHomepage allContractDetails={allContractDetails} />
        </NftMarketContainerTopSection>
        <BottomContainer>
          <LeftContainer>
            <ImageContainer>
              <BackgroundBanner />
            </ImageContainer>
          </LeftContainer>
          <RightContainerWrapper>
            <NameWrapper>
              <NftCategoryHash>
                <NftCategory common>{listedData?.category}</NftCategory>
                <NftHash>
                  <LordImage src={HashImg}></LordImage> {listedData?.hash}
                </NftHash>
              </NftCategoryHash>
              <NameText>{listedData?.name}</NameText>
              <CollectionText>
                <CollectionImg src={CollectionBoxImg}></CollectionImg>
                <CollectionTextFlex>
                  <CollectionTextHead>Collection</CollectionTextHead>

                  <CollectionTextName>
                    {listedData.contractAddress ===
                    "0x8fc3dec6148a9924870f205617c9c26b3010243e"
                      ? "Shootable"
                      : listedData.contractAddress ===
                          "0x6b229c5687d00590606f97045ad65d8dfbfe1bdc" ||
                        listedData.contractAddress ===
                          "0x8a41c16ed29205383cf920b7bc50846852945202"
                      ? "Melee"
                      : listedData.contractAddress ===
                        "0x7eb272ac9b9fec60c5a7921ccc075152a961111c"
                      ? "Characters"
                      : listedData.contractAddress ===
                        "0x69cc97aad84e5aebd72ec147d7b81b72e22c3ece"
                      ? "Vehicle"
                      : null}
                  </CollectionTextName>
                </CollectionTextFlex>
              </CollectionText>
              {/* </NameTextWrapper> */}
            </NameWrapper>

            <TextWrapper>
              {/* <Text> Sale ends May 19, 2023 at 4:34pm </Text> */}
              {/* <Text CommonPistol> Rarity : {rarity || "Common"} </Text> */}
              <Text CommonPistol>
                {" "}
                Price :
                <TextValue>
                  {listedData?.price}{" "}
                  <span style={{ color: "#9b9b9b", fontSize: "16px" }}>
                    {listedData?.currency}
                  </span>
                </TextValue>
              </Text>
            </TextWrapper>

            {/* <Dialog
              open={confirmOpen}
              onClose={() => setConfirmOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Confirm Purchase
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to List this NFT?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setConfirmOpen(false)} color="primary">
                  Cancel
                </Button>
                <Button  color="primary" autoFocus
                onClick={() => {
                
                  setConfirmOpen(false);
                }}
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog> */}

            <ButtonWrapper>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  // setConfirmOpen(true);
                }}
              >
                Listing
              </Button>
            </ButtonWrapper>
          </RightContainerWrapper>
        </BottomContainer>
      </Container>
    </Root>
  );
};

export default ViewNftComponent;
